<h2 mat-dialog-title>Request Payout</h2>

<mat-dialog-content>
  @if (submitSuccess()) {
    <div class="payout-request-dialog__success">
      <h3>Payout Request Submitted!</h3>
      <p>You should receive a confirmation email shortly.</p>
      <p>Your payment will be processed within 5 to 7 business days.</p>
    </div>
  } @else {
    <p class="payout-request-dialog__balance">
      Current Balance: <strong>{{ currentBalance | currency }}</strong>
    </p>

    <form [formGroup]="payoutForm" class="payout-request-dialog__form">
      <mat-form-field appearance="outline" class="payout-request-dialog__field">
        <mat-label>Payment Name</mat-label>
        <input
          matInput
          formControlName="paymentName"
          placeholder="Enter name for payment"
          required
        />
        @if (payoutForm.get("paymentName")?.hasError("required")) {
          <mat-error>Payment name is required</mat-error>
        }
        @if (payoutForm.get("paymentName")?.hasError("minlength")) {
          <mat-error>Payment name must be at least 2 characters</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="payout-request-dialog__field">
        <mat-label>Payment Email</mat-label>
        <input
          matInput
          type="email"
          formControlName="paymentEmail"
          placeholder="Enter email for payment"
          required
        />
        @if (payoutForm.get("paymentEmail")?.hasError("required")) {
          <mat-error>Payment email is required</mat-error>
        }
        @if (payoutForm.get("paymentEmail")?.hasError("email")) {
          <mat-error>Please enter a valid email address</mat-error>
        }
      </mat-form-field>

      @if (submitError()) {
        <div class="payout-request-dialog__error">
          {{ submitError() }}
        </div>
      }

      <p class="payout-request-dialog__notice">
        <strong>Note:</strong> Payouts typically take 5 to 7 business days to
        process.
      </p>
    </form>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!submitSuccess()) {
    <button mat-button (click)="onCancel()" [disabled]="isSubmitting()">
      Cancel
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="payoutForm.invalid || isSubmitting()"
    >
      @if (isSubmitting()) {
        <mat-spinner diameter="20"></mat-spinner>
        Submitting...
      } @else {
        Request Payment
      }
    </button>
  }
</mat-dialog-actions>
